import Sidebar from "../../sidebar";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  getIn,
  FormikHelpers,
} from "formik";
import * as Yup from "yup";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import FormInput from "../../../../components/FormInput";
import { useEffect, useState } from "react";
import {
  addStockCategory,
  getStockCategory,
  updateStockCategory,
} from "./form-section.service";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { validationSchema } from "./validation";

export default function FormSection({ isEdit }: { isEdit: boolean }) {
  const [category, setCategory] = useState<any>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const param = useParams();

  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    let formData = new FormData();
    formData.append("name", values.name);
    formData.append("code", values.code);
    formData.append("order", values.order);
    formData.append("description", values.description);
    if (values.image.file) {
      formData.append("image", values.image.file);
    }
    formData.append("bannerOrder", values.bannerOrder);
    //TODO - remove this hardcoding
    formData.append("metaTitle", values.metaTitle);
    formData.append("metaDescription", values.metaDescription);
    if (isEdit) {
      updateStockCategory(param.id as string, formData)
        .then((response) => {
          toast.success("Stock category updated successfully.");
          navigate("/admin/stock-categories");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      addStockCategory(formData)
        .then((response) => {
          toast.success("Stock category added successfully.");
          navigate("/admin/stock-categories");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    }
  };

  const createImageURL = (key: string) => {
    return `https://d1gdand68muq63.cloudfront.net/categories/96/${key}`;
  };

  useEffect(() => {
    if (isEdit && param.id) {
      getStockCategory(param.id).then((response) => {
        const url = createImageURL(response.data?.image?.key);

        response.data.image = {
          url: url,
          file: null,
        };
        setCategory(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Add Stock Category</h5>
              </div>
              <div className="ec-vendor-card-body">
                {loading ? (
                  "Loading..."
                ) : (
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      name: category ? category.name : "",
                      code: category ? category.code : "",
                      order: 1000,
                      description: category ? category.description : "",
                      metaTitle: "metaTitle",
                      metaDescription: "metaDescription",
                      image: category ? category.image : "",
                      bannerOrder: category ? category.bannerOrder : 0,
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({
                      handleChange,
                      handleBlur,
                      errors,
                      values,
                      touched,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <Form className="add_product_form">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="image-input">
                              <img
                                src={values.image?.url}
                                className="image-preview"
                                alt="img"
                              />
                              <input
                                type="file"
                                accept="image/*"
                                id="imageInput"
                                onChange={(e: any) => {
                                  let formData = new FormData();
                                  setFieldValue("image", {
                                    url: URL.createObjectURL(e.target.files[0]),
                                    file: e.target.files[0],
                                  });
                                }}
                              />
                              <label
                                htmlFor="imageInput"
                                className="image-button"
                              >
                                <i className="fa fa-image"></i>Choose image
                              </label>
                              <div className="invalid-feedback d-block text-danger">
                                {getIn(errors, "image")}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <FormInput
                              label="Category Code"
                              placeholder="Category Code"
                              name="code"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.code}
                              error={getIn(errors, "code")}
                              touched={getIn(touched, "code")}
                              autoFocus
                              isRequired={true}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              label="Category Name"
                              placeholder="Category Name"
                              name="name"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              error={getIn(errors, "name")}
                              touched={getIn(touched, "name")}
                              isRequired={true}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-6">
                            <FormInput
                              label="Description"
                              placeholder="Description"
                              name="description"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.description}
                              error={getIn(errors, "description")}
                              touched={getIn(touched, "description")}
                              isRequired={true}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-12">
                            <div className="btn_right_table">
                              <button
                                className="btn btn-primary mr-1"
                                type="submit"
                              >
                                {isEdit
                                  ? "Save Stock Category"
                                  : "Add Stock Category"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
